// extracted by mini-css-extract-plugin
export default {"price":"_6-z","onSale":"a7-z","msrpLabelPrice":"b7-z","msrpLabel":"c7-z","originalPrice":"d7-z","percentOff":"e7-z"};